import { User } from '@shared/domain/user/user.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { configuration } from 'configuration';

export const authRepositoryImplementation = {
  isAuthenticated: async () => {
    return httpClient
      .get<User>(`${configuration.api.baseUrl}/api/profile`)
      .then(
        () => true,
        (error) => {
          if (error.cause?.response?.status === 401) {
            return false;
          }
          throw error;
        }
      );
  }
};
